import React, { useState } from "react";
import Contact from "../Components/Pages/Contacts/Contact";
import Way from "../Components/Pages/globalComponents/Way";

export default function Contacts() {
  const [title] = useState("Контакты");
  const [way] = useState(["Mary Furnitura", "Контакты"]);

  return (
    <div className="Contacts">
      <Way title={title} way={way} />
      <Contact />
    </div>
  );
}
